import { useReactiveVar } from '@apollo/client';
import { useEffect } from 'react';

import { useUserFromAuth } from '@neo.tax/shared/hooks';
import { AuthenticationState } from '@neo.tax/shared/state';
import { identifyFullStoryUser, identifySentryUser } from '@neo.tax/shared/third-parties';
import { isLocalEnvironment } from '@neo.tax/shared/utils';

import { IdentifiableUser } from '../initialization.types';

export const identifyUserToThirdParties = (identifiableUser: IdentifiableUser): void => {
  if (!isLocalEnvironment()) {
    identifyFullStoryUser(identifiableUser);
  }
  identifySentryUser(identifiableUser);
};

export const useIdentifyUserToThirdParties = (): void => {
  const {
    authenticationServiceState: { authenticationUser },
  } = useReactiveVar(AuthenticationState.authenticationStateVar);
  const { isSuperUserMode, userId } = useUserFromAuth();

  useEffect(() => {
    if (userId && authenticationUser?.uid && authenticationUser?.email && authenticationUser?.displayName) {
      identifyUserToThirdParties({
        id: userId,
        email: authenticationUser.email,
        firebaseUserId: authenticationUser.uid,
        fullName: authenticationUser.displayName,
        isSuperUserMode,
      });
    }
  }, [authenticationUser?.displayName, authenticationUser?.email, authenticationUser?.uid, isSuperUserMode, userId]);
};
